import { DraftConfiguration, ProductType, View } from '@/types';
import { getViewId } from '@/model/printArea/getViewId';
import { getDefaultPrintAreaForView } from './getDefaultPrintAreaForView';

export const getPrintAreaForView = (
  productType: ProductType,
  view: View,
  configurations?: DraftConfiguration[]
) => {
  if (configurations) {
    const configurationOnView = configurations.find(
      ({ printArea }) => getViewId(printArea) === view.id
    );
    if (configurationOnView) {
      return configurationOnView.printArea;
    }
  }

  return getDefaultPrintAreaForView(productType, view);
};
